import { graphql } from "relay-runtime"

export const chUpdateAllPatientAllergiesMutation = graphql`
  mutation chUpdateAllPatientAllergiesMutation($input: Ch_updateAllPatientAllergiesInput!) {
    updateAllPatientAllergies: ch_updateAllPatientAllergies(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on IcdCodeNotUnique {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      patientAllergiesOutput {
        id
        status
        allergies {
          comment
          icdDiagnosis {
            id
            isAssociation
            diagnosisCode
            primaryCode
            secondaryCode
            associationType
            text
          }
        }
      }
    }
  }
`
